// extracted by mini-css-extract-plugin
module.exports = {"tileOverlay":"sj","defaultTileOverlay":"sk","defaultRentalTileOverlay":"sl","tileOverlayOn":"sm","tileOverlayOff":"sn","addRemoveButton":"so","circularFrame":"sp"};